export default class MetaTagHelper {

	public static addMetaDescriptionTag(content: string | null): void {
		this.addMetaTag('description', content);
	}

	private static addMetaTag(name: string, content: string | null): void {
		content = content ?? '';
		const descriptionElement = document.querySelector(`head meta[name="${name}"]`);
		descriptionElement?.setAttribute('content', content);
	}
}